"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  IrisScan1: ['iris-scan-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,12s3-4.5,7.5-4.5S19.5,12,19.5,12s-3,4.5-7.5,4.5S4.5,12,4.5,12Z', 'M10.125 10.125 L13.875 10.125 L13.875 13.875 L10.125 13.875 Z', 'M.75,4.5V2.25A1.5,1.5,0,0,1,2.25.75H4.5', 'M23.25,4.5V2.25a1.5,1.5,0,0,0-1.5-1.5H19.5', 'M.75,19.5v2.25a1.5,1.5,0,0,0,1.5,1.5H4.5', 'M23.25,19.5v2.25a1.5,1.5,0,0,1-1.5,1.5H19.5']],
  IrisScanApproved1: ['iris-scan-approved-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,9.7c.382-.361.741-.727,1.073-1.093a1.662,1.662,0,0,0,0-2.226C20.2,3.5,16.031.684,12,.751,7.969.684,3.8,3.5,1.179,6.385a1.663,1.663,0,0,0,0,2.226,18.849,18.849,0,0,0,7.082,4.955', 'M10.5,10.937A3.749,3.749,0,1,1,15.438,9', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.924,15.505l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5']],
  IrisScanApprovedAlternate: ['iris-scan-approved-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,4.5c-4.031-.075-8.2,3.057-10.821,6.26a2,2,0,0,0,0,2.473C3.746,16.372,7.9,19.575,12,19.5c4.1.077,8.258-3.126,10.824-6.264a2,2,0,0,0,0-2.473C20.2,7.558,16.034,4.426,12,4.5Z', 'M9.003 12.75L11.253 15 15.753 9']],
  IrisScanLock: ['iris-scan-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.823,8.611a1.662,1.662,0,0,0,0-2.226C20.2,3.5,16.031.684,12,.751,7.969.684,3.8,3.5,1.179,6.385a1.663,1.663,0,0,0,0,2.226C3.742,11.435,7.9,14.317,12,14.249', 'M15.75,7.5A3.75,3.75,0,1,1,12,3.75,3.75,3.75,0,0,1,15.75,7.5Z', 'M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75,19.154a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  IrisScanApproved: ['iris-scan-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,4.5c-4.031-.075-8.2,3.057-10.821,6.26a2,2,0,0,0,0,2.473C3.742,16.372,7.9,19.575,12,19.5c4.1.077,8.257-3.126,10.824-6.264a2,2,0,0,0,0-2.473C20.2,7.558,16.031,4.426,12,4.5Z', 'M9.75 12L12 14.25 16.5 9', 'M17.2,12.742A5.246,5.246,0,1,1,14.01,7.148']],
  IrisScan: ['iris-scan', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,5.251C7.969,5.184,3.8,8,1.179,10.885a1.663,1.663,0,0,0,0,2.226C3.742,15.935,7.9,18.817,12,18.749c4.1.068,8.257-2.814,10.824-5.638a1.663,1.663,0,0,0,0-2.226C20.2,8,16.031,5.184,12,5.251Z', 'M15.75,12A3.75,3.75,0,1,1,12,8.25,3.75,3.75,0,0,1,15.75,12Z', 'M0.75 2.25L6.75 8.25', 'M23.25 2.25L17.25 8.25', 'M0.75 21.75L6.75 15.75', 'M23.25 21.75L17.25 15.75']],
  IrisScanDenied: ['iris-scan-denied', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.5 14.999L15 19.499', 'M15 14.999L19.5 19.499', 'M21.75,9.7c.382-.361.741-.727,1.073-1.093a1.662,1.662,0,0,0,0-2.226C20.2,3.5,16.031.684,12,.751,7.969.684,3.8,3.5,1.179,6.385a1.663,1.663,0,0,0,0,2.226,18.849,18.849,0,0,0,7.082,4.955', 'M10.5,10.937A3.749,3.749,0,1,1,15.438,9']],
  IrisScanSearch: ['iris-scan-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,9.7c.382-.361.741-.727,1.073-1.093a1.662,1.662,0,0,0,0-2.226C20.2,3.5,16.031.684,12,.751,7.969.684,3.8,3.5,1.179,6.385a1.663,1.663,0,0,0,0,2.226,18.849,18.849,0,0,0,7.082,4.955', 'M9.745,10.5a3.75,3.75,0,1,1,6.005-3', 'M10.500 15.750 A5.250 5.250 0 1 0 21.000 15.750 A5.250 5.250 0 1 0 10.500 15.750 Z', 'M23.25 23.25L19.486 19.486']],
  IrisScanUser: ['iris-scan-user', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.826,8.611a1.662,1.662,0,0,0,0-2.226C20.2,3.5,16.034.683,12,.751,7.972.683,3.8,3.5,1.182,6.385a1.662,1.662,0,0,0,0,2.226C3.745,11.435,7.9,14.317,12,14.248', 'M12,11.25a3.75,3.75,0,1,1,3.75-3.75', 'M15.378 13.125 A2.625 2.625 0 1 0 20.628 13.125 A2.625 2.625 0 1 0 15.378 13.125 Z', 'M18,16.5a5.25,5.25,0,0,0-5.25,5.25v1.5h10.5v-1.5A5.251,5.251,0,0,0,18,16.5Z']],
  IrisScan2: ['iris-scan-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.500 12.000 A1.500 1.500 0 1 0 13.500 12.000 A1.500 1.500 0 1 0 10.500 12.000 Z', 'M12,4.5c-4.031-.075-8.2,3.057-10.821,6.26a2,2,0,0,0,0,2.473C3.742,16.372,7.9,19.575,12,19.5c4.1.077,8.257-3.126,10.823-6.264a2,2,0,0,0,0-2.473C20.2,7.558,16.031,4.426,12,4.5Z', 'M6.750 12.000 A5.250 5.250 0 1 0 17.250 12.000 A5.250 5.250 0 1 0 6.750 12.000 Z', 'M12 4.5L12 8.25', 'M12 15.75L12 19.5', 'M15.75 12L18.75 12', 'M5.25 12L8.25 12']],
  IrisScanSmartphone: ['iris-scan-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25,14.25v6a3,3,0,0,1-3,3H3.75a3,3,0,0,1-3-3V3.75a3,3,0,0,1,3-3h7.5', 'M0.75 18.57L14.25 18.57', 'M23.25,6.75s-2.25,4.5-6.75,4.5-6.75-4.5-6.75-4.5S12,2.25,16.5,2.25,23.25,6.75,23.25,6.75Z', 'M14.250 6.750 A2.250 2.250 0 1 0 18.750 6.750 A2.250 2.250 0 1 0 14.250 6.750 Z']]
};
exports["default"] = _default;